import { useCatalog } from '../../../contexts/CatalogContext';
import { useAskSarahActions, useSignedInAccount } from '../../../contexts/AccountContext';
import { useSkinPlan } from '../../../hooks/useSkinPlan';
import { founder } from '../../../data/content';
import { currentTip } from '../../../utils/skinTips';
import { btnOnDarkQuiet } from '../../../ui/styles';

/**
 * De tip die er nu toe doet, in Sarahs stem. Staat op het overzicht als er verder niets speelt
 * (de volgende stap "rust"): dan geen knop die roept, alleen een rustige weg naar Sarah.
 */
export function WeeklyTip() {
  const {
    account
  } = useSignedInAccount();
  const {
    openAsk
  } = useAskSarahActions();
  const {
    productById,
    treatmentBySlug
  } = useCatalog();
  const {
    items
  } = useSkinPlan();
  const tip = currentTip(account, items, {
    productById,
    treatmentBySlug
  });
  return <section aria-labelledby="tip-title" className="flex gap-4 bg-ink px-5 py-6 text-shell sm:gap-6 sm:px-8 sm:py-8" data-id="element-6236" data-mp="2xkjk63y7clmk">
      <img src={founder.portrait} alt="" className="h-12 w-12 shrink-0 rounded-full object-cover sm:h-14 sm:w-14" data-id="element-6237" data-mp="2snjn2ijbyt7l" />
      <div className="min-w-0" data-id="element-6238" data-mp="2vvnyalahj7g">
        <p className="text-[14px] text-shell/75" data-id="element-6239" data-mp="7oylsux3netg">Van {founder.firstName}, voor nu</p>
        <h2 id="tip-title" className="mt-1 font-display text-[1.6rem] font-light leading-snug sm:text-[2rem]" data-id="element-6240" data-mp="3q2oabsp2n54e">
          {tip.title}
        </h2>
        <p className="mt-2 max-w-lg text-[15px] leading-relaxed text-shell/85" data-id="element-6241" data-mp="3v2aktudim79i">{tip.body}</p>
        <button type="button" onClick={() => openAsk(items.length ? 'reactie' : 'anders')} aria-haspopup="dialog" className={`${btnOnDarkQuiet} mt-5`} data-id="element-6242" data-mp="mn0qx9js48ct">
          Vraag het {founder.firstName}
        </button>
      </div>
    </section>;
}